import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsProfilesModal from './profilesModal';
import WtsProfilesTechDetailsModal from './profilesTechDetailsModal';

const {
  getWtsProfiles,
  updateWtsProfiles,
} = Actions;

function WtsProfiles({activeTab}) {
  const wtsProfiles = useSelector((state) => state.wtsProfiles.list);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 4) {
      dispatch(getWtsProfiles(areaSelected.id));
    }
  }, [areaSelected, activeTab]);

  const updateStatus = async(e, checkedValue, item) => {
    e.preventDefault();
    dispatch(updateWtsProfiles(areaSelected.id, {
      'data': {
        ...item,
        'status': checkedValue ? 'ACTIVO' : 'INACTIVO',
      },
    }));
    dispatch(getWtsProfiles(areaSelected.id));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'ACTIVO', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'INACTIVO', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value && areaSelected) {
            dispatch(getWtsProfiles(areaSelected.id));
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">PERFIL</span>,
      'accessor': 'description',
    },
    {
      'Header': () => <span className="header-title">DETALLE ROL</span>,
      'accessor': 'role_detail',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO ROL</span>,
      'accessor': 'role_code',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return (
          <Checkbox
            toggle
            checked={item.value === 'ACTIVO'}
            className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'profile_actions',
      'width': 1,
      'Cell': (item) => {
        return (
          <div className='flex center end'>
            <WtsProfilesModal mode='edit' profileToEdit={item.row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column width={16} textAlign='right'>
          <WtsProfilesTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <CommercialTable
            columns={columns}
            data={wtsProfiles}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsProfiles;
